import { Store } from "@tanstack/react-store";
import type { z } from "zod/v4";
import type { GameListSchema } from "@/lib/schema";

export const gameListStore = new Store({
  key: -1,
  data: null as z.infer<typeof GameListSchema> | null,
});

export const playbackStore = new Store({
  url: "",
  status: false,
});
